import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsReviewsPhotoClickedParams = {
  photo_id: string;
  review_id: number;
  trail_id: number;
};

/**
 * Triggered when a user clicks a photo from a trail details review
 * @param params - Attributes to log with the amplitude event
 * @param params.photo_id - The ID of the photo clicked.
 * @param params.review_id - The review id of the review associated with the photo.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsReviewsPhotoClicked = ({ photo_id, review_id, trail_id }: logTrailDetailsReviewsPhotoClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'trail details reviews photo clicked',
    { 'photo id': photo_id, 'review id': review_id, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsReviewsPhotoClicked;
